import { ApiClientError } from '@/api/client'

/**
 * Normalize an unknown mutation error into the backend's stable error code
 * + human message. apiClient.request() throws ApiClientError with `.code`
 * (the envelope's snake_case `error` field) and `.message` — it has NO
 * `.response` property, so the axios-style `err.response?.data?.…` reads
 * silently discard every specific backend message. Route all onError
 * handling through this instead.
 */
export function describeApiError(err: unknown): { code?: string; message: string } {
  if (err instanceof ApiClientError) {
    return { code: err.code, message: err.message || 'Request failed' }
  }
  if (err instanceof Error && err.message) {
    return { message: err.message }
  }
  return { message: 'Request failed' }
}
